import { $useFetch } from "~/composables/useFetch";
import { api } from "~/api/api";
import { type IPasswordResetFormRepository } from "@/assets/ts/interfaces/password-reset-form/IPasswordResetFormRepository";
import { type IPasswordResetState } from "@/assets/ts/interfaces/password-reset-form/IPasswordResetState";
import { type IPasswordResetResult } from "@/assets/ts/interfaces/password-reset-form/IPasswordResetResult";
import { PasswordResetFormHandler } from "@/assets/ts/models/password-reset-form/PasswordResetFormHandler";

export class PasswordResetRepository implements IPasswordResetFormRepository {
	constructor(private passwordResetFormHandler: PasswordResetFormHandler) {}

	get getState(): IPasswordResetState {
		return this.passwordResetFormHandler.getState;
	}

	async sendPasswordResetRequest(): Promise<Ref<object>> {
		const { data } = await $useFetch(api.resetPassword, {
			method: "POST",
			body: {
				type: "auth",
				login: this.getState.email,
			},
			transform: (mutations: any): IPasswordResetResult => ({
				message: mutations.data.data.message,
				success: mutations.data.data.result,
			}),
		});

		this.passwordResetFormHandler.updateResult(data.value);
		this.passwordResetFormHandler.updateRequestStatus(true);

		return data;
	}

	retryRequest(): void {
		this.passwordResetFormHandler.updateRequestStatus(false);
	}
}
